import { render, staticRenderFns } from "./orderHandling.vue?vue&type=template&id=0cd7f4b8&"
import script from "./orderHandling.vue?vue&type=script&lang=js&"
export * from "./orderHandling.vue?vue&type=script&lang=js&"
import style0 from "./orderHandling.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderHandling.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports